import { staticConfig } from "@fidget/common/config/static-config";
import { TemplatePart } from "../chatInputUtilsTypes";

const { templates, compiledTag } = staticConfig;

export type HighlightType = "MENTION" | "PROFANITY";

export interface Highlight {
  type: HighlightType;
  text: string;
}

export const mentionsTemplates: TemplatePart<Highlight>[] = templates.map((template) => {
  const taggedTamplate = compiledTag.opening + template + compiledTag.closing;
  return { key: taggedTamplate, part: { type: "MENTION", text: taggedTamplate } };
});
